export default __webpack_public_path__ + "static/CB_logo-f1f0abcc76be2b8b86008d38bd2f6f06.png";